// extracted by mini-css-extract-plugin
module.exports = {"mobile":"500px","tablet":"768px","reviewsSection":"ReviewsSection_reviewsSection__F8MdB"};